import { render, staticRenderFns } from "./temporarystatistics.vue?vue&type=template&id=d3f07d36&scoped=true"
import script from "./temporarystatistics.vue?vue&type=script&lang=js"
export * from "./temporarystatistics.vue?vue&type=script&lang=js"
import style0 from "./temporarystatistics.vue?vue&type=style&index=0&id=d3f07d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f07d36",
  null
  
)

export default component.exports